/**
 * Быстрое сравнение объектов
 * Используется для простых и небольших по объёму объектов
 * @param a
 * @param b
 */
export function isEqualJsonLikeObjects(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}
